<div class="reports-container">
  <app-settings-nav [activeItem]="'reports'"></app-settings-nav>

  <div class="main-content">
    <div class="page-header">
      <h1 class="page-title">Reports</h1>
      <p class="page-subtitle">Configure how and when reports are delivered to your Slack channel.</p>
    </div>

    <div class="section monthly-plan">
      <h2 class="section-title">Montly Plan</h2>
      <p class="section-description" style="display: none;">Ornare massa aliquam suscipit tellus duis adipiscing arcu viverra aliquam sagittis ultricies duis dui.</p>

      <div class="kpis">
        <div class="kpi-card">
          <div class="kpi-label">REVENUE</div>
          <input class="kpi-input" [value]="formatCurrencyWithCents(planRevenue)" (input)="onKpiInput($event, 'revenue')" />
        </div>
        <div class="kpi-card">
          <div class="kpi-label">TOTAL BUDGET</div>
          <input class="kpi-input" [value]="formatCurrencyWithCents(planTotalBudget)" (input)="onKpiInput($event, 'total')" />
        </div>
        <div class="kpi-card">
          <div class="kpi-label">META</div>
          <input class="kpi-input" [value]="formatCurrencyWithCents(planMetaBudget)" (input)="onKpiInput($event, 'meta')" />
        </div>
        <div class="kpi-card">
          <div class="kpi-label">GOOGLE</div>
          <input class="kpi-input" [value]="formatCurrencyWithCents(planGoogleBudget)" (input)="onKpiInput($event, 'google')" />
        </div>
      </div>
    </div>

    <div class="section pacing-section">
      <!--
      <h2 class="section-title">Pacing Report</h2>

      <div class="weekdays">
        <button class="chip">Monday</button>
        <button class="chip">Tuesday</button>
        <button class="chip">Wednesday</button>
        <button class="chip">Thursday</button>
        <button class="chip">Friday</button>
        <button class="chip">Saturday</button>
        <button class="chip">Sunday</button>
      </div>
-->
      <div class="selectors" style="display: none;">
        <div class="selector">
          <label class="selector-label" style="margin-bottom: 5px;">Time Selector</label>
          <div class="select select-time">
            <span class="left">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <g clip-path="url(#clip0_1_4405)">
                  <path d="M9 0.75C7.36831 0.75 5.77325 1.23385 4.41655 2.14038C3.05984 3.0469 2.00242 4.33537 1.378 5.84286C0.753575 7.35035 0.590197 9.00915 0.908525 10.6095C1.22685 12.2098 2.01259 13.6798 3.16637 14.8336C4.32016 15.9874 5.79017 16.7732 7.39051 17.0915C8.99085 17.4098 10.6497 17.2464 12.1571 16.622C13.6646 15.9976 14.9531 14.9402 15.8596 13.5835C16.7661 12.2268 17.25 10.6317 17.25 9C17.25 6.81196 16.3808 4.71354 14.8336 3.16637C13.2865 1.61919 11.188 0.75 9 0.75ZM9 15.75C7.66498 15.75 6.35994 15.3541 5.2499 14.6124C4.13987 13.8707 3.27471 12.8165 2.76382 11.5831C2.25293 10.3497 2.11925 8.99251 2.3797 7.68314C2.64015 6.37377 3.28303 5.17103 4.22703 4.22703C5.17104 3.28302 6.37377 2.64015 7.68314 2.3797C8.99252 2.11925 10.3497 2.25292 11.5831 2.76381C12.8165 3.2747 13.8707 4.13987 14.6124 5.2499C15.3541 6.35993 15.75 7.66498 15.75 9C15.75 10.7902 15.0388 12.5071 13.773 13.773C12.5071 15.0388 10.7902 15.75 9 15.75Z" fill="white"/>
                  <path d="M9.75001 8.6925V4.5C9.75001 4.30109 9.67099 4.11032 9.53034 3.96967C9.38969 3.82902 9.19892 3.75 9.00001 3.75C8.8011 3.75 8.61033 3.82902 8.46968 3.96967C8.32903 4.11032 8.25001 4.30109 8.25001 4.5V9C8.24944 9.09871 8.26836 9.19655 8.30568 9.28793C8.34301 9.37931 8.398 9.46242 8.46751 9.5325L10.7175 11.7825C10.861 11.9054 11.0455 11.9696 11.2343 11.9623C11.4231 11.955 11.6021 11.8767 11.7357 11.7432C11.8693 11.6096 11.9475 11.4305 11.9548 11.2418C11.9621 11.053 11.8979 10.8685 11.775 10.725L9.75001 8.6925Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_1_4405">
                    <rect width="18" height="18" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </span>
            <span class="value">00 : 00</span>
            <span class="chevron">▼</span>
          </div>
        </div>
        <!--
        <div class="selector">
          <label class="selector-label">Send Report to</label>
          <div class="select select-slack">
            <span class="value">Select Slack Channel</span>
            <span class="chevron">▼</span>
          </div>
        </div>
        -->
      </div>
    </div>
  </div>
</div>


